import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Button,
  Link as MUILink,
  Stack,
  styled,
  TextField,
} from "@mui/material";
import JoinTermsCheckbox from "./JoinTermsCheckbox";

const StyledStack = styled(Stack)`
  height: 100%;
  width: 80%;
  padding-top: 3em;
`;

const JoinForm = ({
  firstName,
  onFirstNameChanged,
  lastName,
  onLastNameChanged,
  email,
  emailRepeat,
  password,
  passwordRepeat,
  termsChecked,
  onInputChanged,
  onTermsCheckedChanged,
  onFormSubmit,
}) => {

  const createAccountEnabled = firstName && lastName && email.value &&
    emailRepeat.value && password.value && passwordRepeat.value && termsChecked;

  return (
    <StyledStack
      component="form"
      onSubmit={onFormSubmit}
      method="POST">
      <Stack
        direction={{
          xs: "column",
          sm: "row",
        }}
        justifyContent="space-between"
        spacing={2}
        mb={2}>
        <TextField
          type="text"
          id="firstName"
          name="firstName"
          label="First Name"
          fullWidth
          required={true}
          value={firstName}
          onChange={(event) => onInputChanged(event, onFirstNameChanged)}
        />
        <TextField
          type="text"
          id="lastName"
          name="lastName"
          label="Last Name"
          fullWidth
          required={true}
          value={lastName}
          onChange={(event) => onInputChanged(event, onLastNameChanged)}
        />
      </Stack>
      <Stack
        direction={{
          xs: "column",
          sm: "row",
        }}
        justifyContent="space-between"
        spacing={2}
        mb={2}>
        <TextField
          type="email"
          id="email"
          name="email"
          label="Email Address"
          fullWidth
          error={email.error}
          helperText={email.helperText}
          required={true}
          value={email.value}
          onChange={(event) => onInputChanged(event, email.setValue)}
        />
        <TextField
          type="email"
          id="emailRepeat"
          name="emailRepeat"
          label="Repeat Email"
          fullWidth
          error={emailRepeat.error}
          helperText={emailRepeat.helperText}
          required={true}
          value={emailRepeat.value}
          onChange={(event) => onInputChanged(event, emailRepeat.setValue)}
        />
      </Stack>
      <Stack
        direction={{
          xs: "column",
          sm: "row",
        }}
        justifyContent="space-between"
        spacing={2}
        mb={.5}>
        <TextField
          type="password"
          id="password"
          name="password"
          label="Password"
          fullWidth
          error={password.error}
          helperText={password.helperText}
          required={true}
          value={password.value}
          onChange={(event) => onInputChanged(event, password.setValue)}
        />
        <TextField
          type="password"
          id="passwordRepeat"
          name="passwordRepeat"
          label="Repeat Password"
          fullWidth
          error={passwordRepeat.error}
          helperText={passwordRepeat.helperText}
          required={true}
          value={passwordRepeat.value}
          onChange={(event) => onInputChanged(event,
            passwordRepeat.setValue)}
        />
      </Stack>
      <JoinTermsCheckbox
        checked={termsChecked}
        onChange={onTermsCheckedChanged}
      />
      <Stack mt={6}>
        <Button
          variant="contained"
          type="submit"
          fullWidth
          style={{ alignSelf: "center" }}
          disabled={!createAccountEnabled}>
          Create Account
        </Button>
        <Stack
          alignItems="end"
          pt={1}
        >
          <RouterLink to="/signin">
            <MUILink
              component="span"
              variant="subtitle2"
            >
              Already a member? Sign in
            </MUILink>
          </RouterLink>
        </Stack>
      </Stack>
    </StyledStack>
  );
};

export default JoinForm;